import React, { ReactNode, useState } from 'react';
import CreditcardFilledIcon from '@atlaskit/icon/glyph/creditcard-filled';
import PaypalIcon from '../../assets/img/paypal-icon.svg';
import AchPaymentIcon from '../../assets/img/ach-payment-icon.svg';
import { PaymentMethodTypeV2 } from '@css-xp/graphtypes/src/generated-types-new';
import './payment-method-type-button.scss';

const PaymentMethodButton: React.FC<{
  onClick: () => void;
  className: string;
  icon: ReactNode;
  paymentMethodName: string;
  testId?: string;
  hideIcon?: boolean;
}> = ({ onClick, className, icon, paymentMethodName, testId, hideIcon }) => {
  return (
    <div data-testid={testId} className={`paymentMethodTypeButton ${className}`} onClick={onClick}>
      <div className="paymentMethodIconAndLabel">
        {!hideIcon && <div className="paymentMethodIcon">{icon}</div>}
        <span>{paymentMethodName}</span>
      </div>
    </div>
  );
};

const PaymentMethodTypeButtons: React.FC<{
  setSelectedPaymentMethodTypeCallback: (paymentMethodType: PaymentMethodTypeV2) => void;
  existingPaymentMethod?: PaymentMethodTypeV2;
  shouldShowACH?: boolean;
}> = ({ setSelectedPaymentMethodTypeCallback, existingPaymentMethod, shouldShowACH }) => {
  const [selectedPaymentMethodType, setSelectedPaymentMethodType] = useState<PaymentMethodTypeV2>(
    existingPaymentMethod || PaymentMethodTypeV2.CARD
  );

  return (
    <div className={`payment-method-button-container ${shouldShowACH ? 'payment-method-ach-button-container' : ''}`}>
      <PaymentMethodButton
        testId="add-payment-method.card"
        onClick={() => {
          setSelectedPaymentMethodType(PaymentMethodTypeV2.CARD);
          setSelectedPaymentMethodTypeCallback(PaymentMethodTypeV2.CARD);
        }}
        className={`card ${selectedPaymentMethodType === PaymentMethodTypeV2.CARD ? 'selected' : ''}`}
        icon={<CreditcardFilledIcon size="small" label="Card" />}
        paymentMethodName={'Card'}
        hideIcon={shouldShowACH}
      />

      <PaymentMethodButton
        testId="add-payment-method.paypal"
        /* @ts-ignore */
        icon={<img src={PaypalIcon} />}
        onClick={() => {
          setSelectedPaymentMethodType(PaymentMethodTypeV2.PAYPAL);
          setSelectedPaymentMethodTypeCallback(PaymentMethodTypeV2.PAYPAL);
        }}
        className={`paypal ${selectedPaymentMethodType === PaymentMethodTypeV2.PAYPAL ? 'selected' : ''}`}
        paymentMethodName="PayPal"
        hideIcon={shouldShowACH}
      />

      {shouldShowACH && (
        <PaymentMethodButton
          testId="add-payment-method.ach"
          /* @ts-ignore */
          icon={<img src={AchPaymentIcon} />}
          onClick={() => {
            setSelectedPaymentMethodType(PaymentMethodTypeV2.ACH);
            setSelectedPaymentMethodTypeCallback(PaymentMethodTypeV2.ACH);
          }}
          className={`${selectedPaymentMethodType === PaymentMethodTypeV2.ACH ? 'selected' : ''}`}
          paymentMethodName="ACH debit"
          hideIcon={true}
        />
      )}
    </div>
  );
};

export { PaymentMethodTypeButtons };
